import { GeoJsonGeometryType } from "../../../services/RuteplanAPI/models/GeoJsonGeometryType";
import { useHeightRestrictions } from "../../../stores/MapLayers/HeightRestrictionStore";
import { HeightRestrictionMarker } from "./HeightRestrictionMarker";

export function HeightRestrictions() {
    const heightRestrictions = useHeightRestrictions();

    return (
        <>
            {heightRestrictions && heightRestrictions.features.map((heightrestriction, index: number) => {
                if (heightrestriction && heightrestriction.geometry.type === GeoJsonGeometryType.LINE_STRING) {
                    return (
                        <div key={heightrestriction.id + index}>
                            <HeightRestrictionMarker heightRestriction={heightrestriction}/>  
                        </div>
                    );
                }
                return(<></>);
            })
            }
        </>
    )
}
